var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgCheckmark = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 15.221,
      height: 11.537,
      viewBox: "0 0 15.221 11.537",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22130",
      "data-name": "Path 22130",
      d: "M2353.65,1393.848h0a1.732,1.732,0,0,0-.622-1.217,1.822,1.822,0,0,0-2.5.167l-5.974,6.591-3.027-3.181a1.821,1.821,0,0,0-2.5-.108,1.734,1.734,0,0,0-.111,2.5l4.366,4.589a1.811,1.811,0,0,0,1.307.557h.021a1.8,1.8,0,0,0,1.314-.589l7.277-8.03A1.722,1.722,0,0,0,2353.65,1393.848Z",
      transform: "translate(-2338.434 -1392.213)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Checkmark.ae89f4fd.svg";
export { ForwardRef as ReactComponent };